import React, { useState } from "react";
import { CustomSwal, maskMobile, maskEmail, showOtpPrompt } from "../services/customSwal";
import { sendOtpLogin, verifyOtp } from "../api/loginApiService";

interface UserInfoProps {
  username: string | null;
  staffId: string | null;
  dob?: string | null;
  mobile?: string | null;
  email?: string | null;
  department?: string | null;
  designation?: string | null;
  company?: string | null;
  profilePhoto?: string | null;
  Everify?: string | null;
  Mverify?: string | null;
  onChangePassword: () => void;
  onVerified?: (type: "email" | "mobile") => void; // optional callback
  onViewLoginHistory: () => void;
}

const UserInfo: React.FC<UserInfoProps> = ({
  username,
  staffId,
  dob,
  mobile,
  email,
  department,
  designation,
  company,
  profilePhoto,
  Everify,
  Mverify,
  onChangePassword,
  onVerified,
  onViewLoginHistory,
}) => {
  const [emailStatus, setEmailStatus] = useState(Everify);
  const [mobileStatus, setMobileStatus] = useState(Mverify);

  const handleVerifyClick = async (type: "email" | "mobile") => {
    const receiver = type === "email" ? email : mobile;
    if (!receiver) return;

    const payload = type === "email" ? { email: receiver } : { mobile: receiver };

    try {
      // Send OTP request
      const payload = type === "email" ? { email: receiver } : { mobile: receiver };
      const sendRes = await sendOtpLogin(payload);

      if (!sendRes.success) {
        CustomSwal.fire('Try again.', 'Failed to send OTP', 'warning');
        return;
      }

      // Mask receiver for prompt
      const maskedReceiver =
        type === "email" ? maskEmail(receiver) : maskMobile(receiver);

      let attempts = 0;
      let verified = false;

      while (attempts < 3 && !verified) {
        const otp = await showOtpPrompt(maskedReceiver);
        if (!otp) break; // user cancelled
        if (!staffId) break;

        const verifyRes = await verifyOtp(payload, otp, staffId);
        if (verifyRes?.verified) {
          CustomSwal.fire('Verified', "Otp verified successfully", 'success');
          verified = true;
          type === "email" ? setEmailStatus("Y") : setMobileStatus("Y");
          onVerified?.(type);
        } else {
          attempts++;
          if (attempts < 3) CustomSwal.fire('Try again', "Incorrect OTP", 'warning');
        }
      }

      if (!verified) CustomSwal.fire('Try again', "OTP verification failed.", 'warning');
    } catch (err) {
      console.error(err);
    }
  };

  const renderVerifyIcon = (
    status?: string | null,
    type?: "email" | "mobile"
  ) => {
    if (status === "Y") {
      return (
        <i
          className="fas fa-check-circle verify-success"
          title="Verified"
        ></i>
      );
    } else if (status === "N") {
      return (
        <i
          className="fas fa-exclamation-circle verify-warning clickable"
          title="Not Verified"
          onClick={() => type && handleVerifyClick(type)}
        ></i>
      );
    }
    return null;
  };

  return (
    <div className="user-info">
      {/* Profile Row */}
      <div className="profile-row">
        <div className="profile-top-left">
          {profilePhoto ? (
            <img
              src={profilePhoto}
              alt="Profile Photo"
              className="profile-img"
            />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="profile-placeholder"
            >
              <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
            </svg>
          )}
        </div>
        <div className="profile-username">
          <h3>{username}</h3>
          <h6>({staffId})</h6>
        </div>
      </div>

      {/* Details */}
      <div className="details-section">
        <table className="user-details-table">
          <tbody>
            <tr>
              <th className="userInHead">Institution</th>
              <td className="infodot">:</td>
              <td className="infoValue">{company || ""}</td>
            </tr>
            <tr>
              <th className="userInHead">Department</th>
              <td className="infodot">:</td>
              <td className="infoValue">{department || ""}</td>
            </tr>
            <tr>
              <th className="userInHead">Designation</th>
              <td className="infodot">:</td>
              <td className="infoValue">{designation || ""}</td>
            </tr>
            <tr>
              <th className="userInHead">DOB</th>
              <td className="infodot">:</td>
              <td className="infoValue">{dob || ""}</td>
            </tr>
            <tr>
              <th className="userInHead">Mobile</th>
              <td className="infodot">:</td>
              <td className="infoValue">
                {maskMobile(mobile || "")}{" "}
                {renderVerifyIcon(mobileStatus, "mobile")}
              </td>
            </tr>
            <tr>
              <th className="userInHead">Email</th>
              <td className="infodot">:</td>
              <td className="infoValue">
                {maskEmail(email || "")} {renderVerifyIcon(emailStatus, "email")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="user-Btn">
        <button className="btn change-pwd" onClick={onChangePassword}>
          Change Password
        </button>
        {/* <button
          className="btn btn-secondary view-His-btn"
          onClick={onViewLoginHistory} // call the prop instead of local fetch
        >
          View Login History
        </button> */}
        <a
          href="#"
          className="view-His-link"
          onClick={(e) => {
            e.preventDefault(); // prevent page jump
            onViewLoginHistory();
          }}
        >
          View Login History
        </a>
      </div>
    </div>
  );
};

export default UserInfo;
